import { loadFundingSources } from './fundingSourceApi';
import { createLookup } from './lookup';

/** Per clinic and date, since tasks ask often and a payer can be renamed. */
const payerNames = createLookup({
  read: async (key) => {
    const [clinicId, asOf] = key.split('|');
    const payers = await loadFundingSources(clinicId, asOf);

    return new Map((payers ?? []).map((payer) => [payer.fundingSourceId, payer.name]));
  },
  label: 'a clinic\'s payer names',
});

/**
 * A clinic's payers by series id, named as the versions in force on `asOf` name them. Empty when
 * they could not be read.
 *
 * @param {string} clinicId
 * @param {string} asOf - a calendar date, read from the clock by the caller
 * @returns {Promise<Map<string, string>>}
 */
// eslint-disable-next-line import/prefer-default-export
export async function payerNamesAt(clinicId, asOf) {
  return (await payerNames.load(`${clinicId}|${asOf}`)) ?? new Map();
} // payerNamesAt()
